export enum UserLoginMode {
    Registered = 'Registered',
    LoggedIn = 'LoggedIn',
}